import usePagination from './usePagination'

export default function useLoading(
  customLoading: boolean,
  queryLoading: boolean,
  bodyLength: number,
  data: unknown
) {
  const { pagination } = usePagination()

  if (customLoading) {
    return true
  }

  if (pagination.infiniteScroll && bodyLength > 0) {
    return false
  }

  if (pagination.kind === 'offset') {
    return queryLoading && !data
  }

  if (pagination.kind === 'cursor') {
    return queryLoading
  }

  return false
}
